import { render, staticRenderFns } from "./GameThemeSection.vue?vue&type=template&id=e52c214e"
import script from "./GameThemeSection.vue?vue&type=script&lang=js"
export * from "./GameThemeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports